import React from 'react';
import Button from '../../../components/controls/button';
import Style from './EmailConfirmation.module.css';
import { useHistory } from 'react-router';
import HanshiWhiteLogo from '../../../assets/hanshi/full-white-sm.svg';
import { ArrowLeft } from "../../../modules/default-svg";

const EmailConfirmation = () => {
  const history = useHistory();

  const handleSendLinkAgain = async () => {
    history.push('/resend-email')
  };
  
  const handleBack = async () => {
    history.push('/')
  };

  return (
    <div className={Style.mainWrapper}>
      <div className={Style.card}>
        <div className="w-full flex justify-center pt-10 mb-5">
          <img src={HanshiWhiteLogo} alt="Hanshi Logo" className="w-32 md:w-48" />
        </div>
        <div className={Style.cardContent}>
          <div className={Style.cardTitleContainer}>
            <p className={`${Style.cardTitle} text-xl-700`}>Email sent successfully</p>
            <p className={`${Style.cardDescription} text-sm-500`}>You can check your inbox for details</p>
          </div>
        </div>
        <div className={Style.btnWrapper}>
          <Button btnClass="btn_w100 btn_w100_primary" label="Didn't receive link?" cssClass={`${Style.sendMailBtn}`} clickHandler={handleSendLinkAgain} />
          <div
            className="d-flex align-items-center"
            onClick={handleBack}
          >
            <ArrowLeft />
            <p className="my-3 text-xsm-500 text-[#5e5e5e] hover:text-[#342c82] hover:cursor-pointer">
                Back to Sign In
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;